<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-select
        placeholder="请选择是否开启"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in enables"
          :key="item.value"
        ></el-option>
      </el-select> -->
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="公告标题" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="公告内容"
        align="center"
        width="360"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="links" label="公告链接" align="center" width="240">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.links && scope.row.links.length > 0"
            size="small"
            @click="viewLinkConfig(scope.row.links)"
            >点击查看</el-button
          ><el-button v-else size="small" disabled>点击查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="enable" label="是否开启" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.enable">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="公告标题:"
          size="small"
          prop="title"
          style="width: 480px"
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item
          label="公告内容:"
          size="small"
          prop="content"
          style="width: 480px"
        >
          <el-input
            type="textarea"
            :rows="10"
            v-model="form.content"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接配置">
          <el-button type="primary" size="small" @click="openLinkConfig"
            >链接配置</el-button
          >
        </el-form-item>
        <el-form-item
          size="small"
          label="是否开启:"
          prop="status"
          style="width: 480px"
        >
          <el-select v-model="form.enable" placeholder="请选择是否开启">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in enables"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="跳转链接配置"
      :visible.sync="linkDialogVisible"
      width="1010px"
      @before-close="linkHandleClose"
    >
      <div
        v-for="(item, index) in tempLinks"
        :key="index"
        style="position:relative"
      >
        <div v-if="tempLinks.length !== 0">
          <span style="margin:10px 2px 10px 10px">链接文本</span>
          <el-input
            type="text"
            size="small"
            clearable
            v-model="tempLinks[index].text"
            style="width:180px;"
          ></el-input>
          <span style="margin:10px 2px 10px 10px">跳转方式</span>
          <el-select
            style="width: 150px; margin:5px 0px"
            v-model="tempLinks[index].link_type"
            clearable
            size="small"
            placeholder="请选择跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span style="margin:10px 2px 10px 10px">链接地址</span>
          <el-input
            type="text"
            size="small"
            clearable
            v-if="tempLinks[index].link_type == 1"
            v-model="tempLinks[index].url"
            style="width:150px;"
          ></el-input>
          <el-select
            style="width: 150px; margin:5px 0px"
            v-model="tempLinks[index].url"
            size="small"
            placeholder="链接地址"
            filterable
            clearable
            v-if="tempLinks[index].link_type == 2"
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
          <template
            v-if="
              tempLinks[index].url == 'yinseinner://actress?id=' ||
                tempLinks[index].url == 'yinseinner://audiobook?id=' ||
                tempLinks[index].url == 'yinseinner://video?id=' ||
                tempLinks[index].url == 'yinseinner://cartoon_video?id=' ||
                tempLinks[index].url == 'yinseinner://vipCard?id=' ||
                tempLinks[index].url == 'yinseinner://comics?id=' ||
                tempLinks[index].url == 'yinseinner://module?id=' ||
                tempLinks[index].url == 'yinseinner://acg_module?id=' ||
                tempLinks[index].url == 'yinseinner://playlist?id=' ||
                tempLinks[index].url == 'yinseinner://picture_playlist?id=' ||
                tempLinks[index].url == 'yinseinner://postdetail?id=' ||
                tempLinks[index].url == 'yinseinner://section?id=' ||
                tempLinks[index].url == 'yinseinner://pk_page?id=' ||
                tempLinks[index].url == 'yinseinner://album?id='
            "
          >
            <span style="margin:10px 2px 10px 10px">内链ID</span>
            <el-input
              type="text"
              size="small"
              clearable
              v-model="tempLinks[index].objID"
              style="width:180px;"
            ></el-input>
          </template>
          <i
            class="el-icon-circle-plus"
            v-if="index === tempLinks.length - 1"
            style="color:#67c23a;font-size:24px;cursor:pointer;position:absolute;right:20px;top:15px"
            @click="addBtn"
          ></i>
          <i
            class="el-icon-remove"
            v-if="tempLinks.length > 1"
            style="color:#f56c6c;font-size:24px;cursor:pointer;position:absolute;right:-5px;top:15px"
            @click="removeBtn(item)"
          ></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="linkHandleClose"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看跳转链接配置 -->
    <el-dialog
      title="跳转链接配置"
      :visible.sync="linkConfigDialog"
      width="1010px"
      @before-close="linkHandleClose"
    >
      <div class="tip">(此处仅支持查看，如要修改请点击编辑按钮)</div>
      <div
        v-for="(item, index) in viewLinks"
        :key="index"
        style="position:relative"
      >
        <div v-if="viewLinks.length !== 0">
          <span style="margin:10px 2px 10px 10px">链接文本</span>
          <el-input
            type="text"
            size="small"
            v-model="viewLinks[index].text"
            style="width:180px;"
          ></el-input>
          <span style="margin:10px 2px 10px 10px">跳转方式</span>
          <el-select
            style="width: 150px; margin:5px 0px"
            v-model="viewLinks[index].link_type"
            size="small"
            placeholder="请选择跳转方式"
          >
            <el-option
              v-for="item in linkTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span style="margin:10px 2px 10px 10px">链接地址</span>
          <el-input
            type="text"
            size="small"
            v-if="viewLinks[index].link_type == 1"
            v-model="viewLinks[index].url"
            style="width:150px;"
          ></el-input>
          <el-select
            style="width: 150px; margin:5px 0px"
            v-model="viewLinks[index].url"
            size="small"
            placeholder="链接地址"
            filterable
            v-if="viewLinks[index].link_type == 2"
          >
            <el-option
              v-for="item in linkList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
          <template
            v-if="
              viewLinks[index].url == 'yinseinner://actress?id=' ||
                viewLinks[index].url == 'yinseinner://audiobook?id=' ||
                viewLinks[index].url == 'yinseinner://video?id=' ||
                viewLinks[index].url == 'yinseinner://cartoon_video?id=' ||
                viewLinks[index].url == 'yinseinner://vipCard?id=' ||
                viewLinks[index].url == 'yinseinner://comics?id=' ||
                viewLinks[index].url == 'yinseinner://module?id=' ||
                viewLinks[index].url == 'yinseinner://acg_module?id=' ||
                viewLinks[index].url == 'yinseinner://playlist?id=' ||
                viewLinks[index].url == 'yinseinner://picture_playlist?id=' ||
                viewLinks[index].url == 'yinseinner://postdetail?id=' ||
                viewLinks[index].url == 'yinseinner://section?id=' ||
                viewLinks[index].url == 'yinseinner://pk_page?id=' ||
                viewLinks[index].url == 'yinseinner://album?id='
            "
          >
            <span style="margin:10px 2px 10px 10px">内链ID</span>
            <el-input
              type="text"
              size="small"
              v-model="viewLinks[index].objID"
              style="width:180px;"
            ></el-input>
          </template>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="linkHandleClose"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      rules: {
        title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入公告内容", trigger: "blur" },
        ],
      },
      enables: [
        {
          label: "开启",
          value: true,
        },
        {
          label: "关闭",
          value: false,
        },
      ],
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        title: undefined, // 公告标题
        content: undefined, // 公告内容
        links: undefined, // 公告链接
        enable: true, // 是否启用
      },
      linkDialogVisible: false,
      tempLinks: [
        {
          text: undefined, // 替换的文本
          link_type: 1, // 链接类型，默认外部
          url: undefined, // 链接地址
          objID: undefined, // 内链的ID
        },
      ],
      linkTypeList: [
        { label: "外部浏览器跳转", value: 1 },
        { label: "内部浏览器跳转", value: 2 },
      ],
      linkList: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "在线客服", value: "yinseinner://kefu" },
        { label: "分享推广", value: "yinseinner://universal_agent" },
        { label: "专题详情", value: "yinseinner://section?id=" },
        { label: "视频播单详情", value: "yinseinner://playlist?id=" },
        { label: "图片播单详情", value: "yinseinner://picture_playlist?id=" },
        { label: "播单", value: "yinseinner://playlistModule" },
        { label: "帖子详情", value: "yinseinner://postdetail?id=" },
        { label: "普通视频详情", value: "yinseinner://video?id=" },
        { label: "动漫视频详情", value: "yinseinner://cartoon_video?id=" },
        { label: "指定会员卡", value: "yinseinner://vipCard?id=" },
        { label: "直播", value: "yinseinner://live" },
        // { label: "女优详情", value: "yinseinner://actress?id=" },
        // { label: "有声小说详情", value: "yinseinner://audiobook?id=" },
        // { label: "漫画详情", value: "yinseinner://comics?id=" },
        // { label: "福利任务", value: "yinseinner://taskHall" },
        // { label: "绑定手机号", value: "yinseinner://binding_page" },
        // { label: "亚模块分类", value: "yinseinner://module?id=" },
        // { label: "acg亚模块分类", value: "yinseinner://acg_module?id=" },
        // { label: "打榜pk", value: "yinseinner://pk_page?id=" },
        // { label: "套图详情", value: "yinseinner://album?id=" },
        // { label: "排行榜", value: "yinseinner://rankingList" },
        // { label: "套图站", value: "yinseinner://photoSetStation" },
        // { label: "女优", value: "yinseinner://actressModule" },
        // { label: "短视频", value: "yinseinner://shortVideo" },
        // { label: "神评", value: "yinseinner://godComment_page" },
      ],
      linkConfigDialog: false,
      viewLinks: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getNotificationList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.title = param.title;
        this.form.content = param.content;
        this.form.enable = param.enable;
        if (param.links && param.links.length) {
          // 组装回显数据
          this.tempLinks = param.links.map((item) => {
            item.link_type = 1; // 默认为外部跳转
            if (
              item.url.indexOf("vip_page") !== -1 ||
              item.url.indexOf("wallet_page") !== -1 ||
              item.url.indexOf("live") !== -1 ||
              item.url.indexOf("universal_agent") !== -1 ||
              item.url.indexOf("taskHall") !== -1 ||
              item.url.indexOf("binding_page") !== -1 ||
              item.url.indexOf("kefu") !== -1 ||
              item.url.indexOf("rankingList") !== -1 ||
              item.url.indexOf("photoSetStation") !== -1 ||
              item.url.indexOf("playlistModule") !== -1 ||
              item.url.indexOf("actressModule") !== -1 ||
              item.url.indexOf("shortVideo") !== -1 ||
              item.url.indexOf("actress") !== -1 ||
              item.url.indexOf("audiobook") !== -1 ||
              item.url.indexOf("video") !== -1 ||
              item.url.indexOf("cartoon_video") !== -1 ||
              item.url.indexOf("vipCard") !== -1 ||
              item.url.indexOf("comics") !== -1 ||
              item.url.indexOf("module") !== -1 ||
              item.url.indexOf("acg_module") !== -1 ||
              item.url.indexOf("playlist") !== -1 ||
              item.url.indexOf("picture_playlist") !== -1 ||
              item.url.indexOf("postdetail") !== -1 ||
              item.url.indexOf("section") !== -1 ||
              item.url.indexOf("pk_page") !== -1 ||
              item.url.indexOf("album") !== -1
            ) {
              item.link_type = 2;
            }
            return item;
          });
        }
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      let copyLinks = JSON.parse(JSON.stringify(this.tempLinks));
      this.form.links = copyLinks.filter((item) => {
        delete item.link_type;
        return item;
      });
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addNotification(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      let copyLinks = JSON.parse(JSON.stringify(this.tempLinks));
      this.form.links = copyLinks.filter((item) => {
        delete item.link_type;
        return item;
      });
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateNotification(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.title}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delNotification(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.title = undefined;
      this.form.content = undefined;
      this.tempLinks = [
        {
          text: undefined, // 替换的文本
          link_type: 1, // 链接类型，默认外部
          url: undefined, // 链接地址
          objID: undefined, // 内链的ID
        },
      ];
      this.form.enable = true;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // ----------------------------链接相关--------------------------
    openLinkConfig() {
      this.linkDialogVisible = true;
    },
    linkHandleClose() {
      this.linkDialogVisible = false;
      this.linkConfigDialog = false;
      this.viewLinks = [];
    },
    // 增加数量
    addBtn() {
      this.tempLinks.push({
        objID: undefined,
        text: undefined,
        url: undefined,
      });
    },
    // 减少数量
    removeBtn(value) {
      this.tempLinks = this.tempLinks.filter((item) => {
        if (item.text !== value.text) {
          return item;
        }
      });
    },
    viewLinkConfig(linkConfig) {
      // 组装回显数据
      let linksArr = linkConfig.map((item) => {
        item.link_type = 1; // 默认为外部跳转
        if (
          item.url.indexOf("vip_page") !== -1 ||
          item.url.indexOf("live") !== -1 ||
          item.url.indexOf("universal_agent") !== -1 ||
          item.url.indexOf("taskHall") !== -1 ||
          item.url.indexOf("binding_page") !== -1 ||
          item.url.indexOf("kefu") !== -1 ||
          item.url.indexOf("rankingList") !== -1 ||
          item.url.indexOf("photoSetStation") !== -1 ||
          item.url.indexOf("playlistModule") !== -1 ||
          item.url.indexOf("actressModule") !== -1 ||
          item.url.indexOf("shortVideo") !== -1 ||
          item.url.indexOf("actress") !== -1 ||
          item.url.indexOf("audiobook") !== -1 ||
          item.url.indexOf("video") !== -1 ||
          item.url.indexOf("cartoon_video") !== -1 ||
          item.url.indexOf("vipCard") !== -1 ||
          item.url.indexOf("comics") !== -1 ||
          item.url.indexOf("module") !== -1 ||
          item.url.indexOf("acg_module") !== -1 ||
          item.url.indexOf("playlist") !== -1 ||
          item.url.indexOf("picture_playlist") !== -1 ||
          item.url.indexOf("postdetail") !== -1 ||
          item.url.indexOf("section") !== -1 ||
          item.url.indexOf("pk_page") !== -1 ||
          item.url.indexOf("album") !== -1
        ) {
          item.link_type = 2;
        }
        return item;
      });
      this.viewLinks = JSON.parse(JSON.stringify(linksArr));
      this.linkConfigDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
.tip {
  color: red;
  font-weight: 500;
  font-size: 18px;
}
</style>
